module.exports = __webpack_public_path__ + "img/hot-open.28b29b92.svg";